import React, {Component} from 'react';
import L from 'leaflet';
import PropTypes from 'prop-types';
import {propTypes, defaultProps} from 'react-props-decorators';
import AbstractMapLayer from "components/ui/map/base/layer";
import {connect} from "react-redux";
import {getStopPointsWithBounds} from "store/reducers/routes/routes";
import StopPointMarker from "components/ui/map/markers/stop-point-marker";
import _ from 'lodash';

@propTypes({
    onStopPointClick: PropTypes.func,
    onStopPointDblClick: PropTypes.func,
})

@defaultProps({
    onStopPointClick: null,
    onStopPointDblClick: () => {
    },
})

@connect((state) => ({}), {getStopPointsWithBounds})

export default class StopPointsMtaLayer extends AbstractMapLayer {

    state = {
        stopPoints: [],
        editorUuid: null,
        requestIndex: 0,
    };

    loadStopPointsCallback = ::this.loadStopPoints;

    componentWillMount() {
        super.componentWillMount();

        this.props.leafletMap.on('moveend', this.loadStopPointsCallback);

        this.loadStopPoints();
    }

    componentWillUnmount() {
        super.componentWillUnmount();

        this.props.leafletMap.off('moveend', this.loadStopPointsCallback);
    }

    async loadStopPoints() {
        await this.setState({
            requestIndex: this.state.requestIndex + 1,
        });

        const requestIndex = this.state.requestIndex;
        const boundingBox = this.props.map.getBoundingBox();
        const zoom = this.props.map.getZoom();
        const response = await this.props.getStopPointsWithBounds(boundingBox, zoom);
        if (this.state.requestIndex === requestIndex) {
            if (response.isOk) {
                this.setState({
                    stopPoints: response.payload.items,
                });
            } else {
                response.showErrors();
            }
        }
    }

    onEditClick(uuid) {
        this.setState({
            editorUuid: uuid,
        });
    }

    closeEditor() {
        this.setState({
            editorUuid: null,
        });
    }

    getEditor() {
        return (
            <StopPointsEditor
                mode="edit"
                uuid={this.state.editorUuid}
                onSubmit={::this.closeEditor}
                onClose={::this.closeEditor}
                />
        );
    }

    render() {
        const editor = this.state.editorUuid ? this.getEditor() : null;

        return (
            <div>
                {editor}
                <div style={{display: 'none'}}>
                    {this.state.stopPoints.map(::this.renderStopPoint)}
                </div>
            </div>
        );
    }

    renderStopPoint(stopPoint) {
        const color = this.getColor(stopPoint);

        return (
            <StopPointMarker
                key={stopPoint.uuid + ':' + color}
                {...this.props}
                latitude={stopPoint.latitude}
                longitude={stopPoint.longitude}
                item={stopPoint}
                permanentTooltip={this.props.selectedStopPoint === stopPoint.uuid}
                onClick={this.props.onStopPointClick ? this.onClick.bind(this, stopPoint) : null}
                onDblClick={this.props.onStopPointDblClick.bind(this, stopPoint.uuid, stopPoint.latitude, stopPoint.longitude)}
                onEditClick={this.onEditClick.bind(this, stopPoint.uuid)}
                onScheduleClick={this.onScheduleClick.bind(this, stopPoint)}
                onFromHereClick={this.onFromHereClick.bind(this, stopPoint)}
                onToHereClick={this.onToHereClick.bind(this, stopPoint)}
                color={color}
            />
        );
    }

    getColor(stopPoint) {
        const selectedStopPoints = this.props.selectedStopPoints;

        if (_.indexOf(selectedStopPoints, stopPoint.uuid) !== -1) {
            return 'red';
        }

        return null;
    }

    onClick(stopPoint) {
        this.props.onStopPointClick(stopPoint);
    }

    onScheduleClick(stopPoint) {
        this.props.onStopPointScheduleClick(stopPoint);
    }

    onFromHereClick(stopPoint) {
        this.props.onStopPointFromHereClick(stopPoint);
    }

    onToHereClick(stopPoint) {
        this.props.onStopPointToHereClick(stopPoint);
    }

}



// WEBPACK FOOTER //
// ./src/components/ui/map/layers/stop-points-mta.js